import { LoginFormLayout } from "../../layouts/LoginFormLayout/LoginFormLayout";
import React from "react";
import { Typography } from "antd";

import classes from "./style/Documents.module.css";

const { Text, Title } = Typography;

/**
 * Компонент отображает полный текст политики обработки персональных данных компании.
 */
export function PolicyPersonalDataProcessingDocument(): JSX.Element {
  return (
    <LoginFormLayout
      childrenContainerClassName={classes.childrenContainerClassName}
      className={classes.documentLayout}
      showSupportText={false}
    >
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <Title className={classes.documentHeader} level={1}>
            ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ В ООО «АЙТИ ОНЛАЙН»
          </Title>
          <section>
            <Title className={classes.sectionHeader} level={4}>
              1. Общие положения
            </Title>
            <p>
              <Text className={classes.sectionText}>
                1.1. Настоящая политика обработки персональных данных определяет
                порядок обработки персональных данных и устанавливает меры по
                обеспечению безопасности персональных данных, предпринимаемые
                ООО «Айти Онлайн» (ИНН 1686007432, ОГРН 1221600022423,
                юридический адрес Российская Федерация, 420029, Республика
                Татарстан, г Казань, ул Сибирский Тракт, зд. 34 к. 1, помещ.
                1002 офис 1) (далее – Оператор) в соответствии с Федеральным
                законом от 27 июля 2006 г. № 152-ФЗ «О персональных данных»
                (далее – Закон о персональных данных).
              </Text>
            </p>
            <p>
              <Text className={classes.sectionText}>
                1.2. Оператор ставит своей важнейшей целью и условием
                осуществления своей деятельности соблюдение прав и свобод
                человека и гражданина при обработке его персональных данных, в
                том числе защиты прав на неприкосновенность частной жизни,
                личную и семейную тайну.
              </Text>
            </p>
            <p>
              <Text className={classes.sectionText}>
                1.3. Настоящая политика Оператора обработки персональных данных
                (далее – Политика) применяется в отношении всех персональных
                данных, которые обрабатывает Оператор.
              </Text>
            </p>
          </section>

          <section>
            <Title className={classes.sectionHeader} level={4}>
              2. Основные понятия, используемые в Политике
            </Title>

            <p>
              <Text className={classes.sectionText}>
                2.1. <strong>Персональные данные </strong> – любая информация,
                относящаяся к прямо или косвенно определенному или определяемому
                физическому лицу (субъекту персональных данных).
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.2.{" "}
                <strong>
                  Персональные данные, разрешённые субъектом персональных данных
                  для распространения
                </strong>
                – персональные данные, доступ неограниченного круга лиц к
                которым предоставлен субъектом персональных данных путем дачи
                согласия на обработку персональных данных, разрешенных субъектом
                персональных данных для распространения в порядке,
                предусмотренном Законом о персональных данных (далее –
                персональные данные, разрешенные для распространения).
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.3. <strong>Обработка персональных данных</strong> – любое
                действие (операция) или совокупность действий (операций),
                совершаемых с использованием средств автоматизации или без
                использования таких средств с персональными данными, включая
                сбор, запись, систематизацию, накопление, хранение, уточнение
                (обновление, изменение), извлечение, использование, передачу
                (распространение, предоставление, доступ), блокирование,
                удаление, уничтожение персональных данных.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.4. <strong>Оператор</strong> – государственный орган,
                муниципальный орган, юридическое или физическое лицо,
                самостоятельно или совместно с другими лицами организующее и
                (или) осуществляющее обработку персональных данных, а также
                определяющее цели обработки персональных данных, состав
                персональных данных, подлежащих обработке, действия (операции),
                совершаемые с персональными данными.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.5.{" "}
                <strong>
                  Автоматизированная обработка персональных данных
                </strong>{" "}
                – обработка персональных данных с помощью средств вычислительной
                техники.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.6. <strong>Распространение персональных данных</strong> –
                действия, направленные на раскрытие персональных данных
                неопределенному кругу лиц.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.7. <strong>Предоставление персональных данных</strong> –
                действия, направленные на раскрытие персональных данных
                определенному лицу или определенному кругу лиц.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.8. <strong>Блокирование персональных данных</strong> –
                временное прекращение обработки персональных данных (за
                исключением случаев, если обработка необходима для уточнения
                персональных данных).
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.9. <strong>Уничтожение персональных данных</strong> – любые
                действия, в результате которых становится невозможным
                восстановить содержание персональных данных в информационной
                системе персональных данных и (или) в результате которых
                уничтожаются материальные носители персональных данных.
              </Text>
            </p>

            <p>
              {" "}
              <Text className={classes.sectionText}>
                2.10. <strong>Сайт</strong> – совокупность графических и
                информационных материалов, а также программ для ЭВМ и баз
                данных, обеспечивающих их доступность в сети Интернет по
                сетевому адресу{" "}
                <a href="https://tatbg.ru/" target="__blank">
                  https://tatbg.ru/
                </a>
                .
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.11. <strong>Пользователь</strong> – любой посетитель сайта{" "}
                <a href="https://tatbg.ru/" target="__blank">
                  https://tatbg.ru/
                </a>{" "}
                (включая контрагентов, представляющих интересы юридических лиц и
                иных субъектов).
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                2.12. <strong>Личный кабинет</strong> – совокупность защищенных
                страниц Сайта, созданных в результате регистрации Пользователя и
                доступных при вводе его аутентификационных данных (адреса
                электронной почты и пароля) в предусмотренные для этого поля на
                Сайте.
              </Text>
            </p>
          </section>

          <section>
            <Title className={classes.sectionHeader} level={4}>
              3. Цели обработки персональных данных
            </Title>

            <p>
              <Text className={classes.sectionText}>
                3.1. Обработка персональных данных ограничивается достижением
                конкретных, заранее определенных и законных целей. Не
                допускается обработка персональных данных, несовместимая с
                целями сбора персональных данных.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.2. Обработке подлежат только персональные данные, которые
                отвечают целям их обработки.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.3. Оператор обрабатывает персональные данные исключительно в
                следующих <strong>целях:</strong>
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.3.1. предоставление доступа субъекту персональных данных к
                личному кабинету, сервисам, информации и/или материалам,
                содержащимся на сайте{" "}
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
                ;
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.3.2. осуществление посреднических услуг зарегистрированным
                пользователям на сайте{" "}
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
                ;
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.3.3. направление информационных электронных писем субъекту
                персональных данных;
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.3.4. проведение консультаций по вопросам, касающихся сервисов,
                информации и материалов, содержащихся на сайте{" "}
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
                ;
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.3.5. улучшение функционирования сайта и проведения
                статистических исследований
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                3.3.6. предоставление пользователю сайта доступа к функционалу
                личного кабинета сайта
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
                ;
              </Text>
            </p>
          </section>

          <section>
            <Title className={classes.sectionHeader} level={4}>
              4. Правовые основания обработки персональных данных
            </Title>

            <p>
              <Text className={classes.sectionText}>
                4.1. Правовым основанием обработки персональных данных являются:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>Конституция Российской Федерации;</Text>
              </li>
              <li className={classes.markListItem}>
                <Text>Гражданский кодекс Российской Федерации;</Text>
              </li>
              <li className={classes.markListItem}>
                <Text>Трудовой кодекс Российской Федерации;</Text>
              </li>
              <li className={classes.markListItem}>
                <Text>Налоговый кодекс Российской Федерации;</Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  Федеральный закон от 08.02.1998 № 14-ФЗ «Об обществах с
                  ограниченной ответственностью»;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  Федеральный закон от 26.12.1995 № 208-ФЗ «Об акционерных
                  обществах»;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  Федеральный закон от 06.12.2011 № 402-ФЗ «О бухгалтерском
                  учете»;
                </Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  Федеральный закон от 15.12.2001 № 167-ФЗ «Об обязательном
                  пенсионном страховании в Российской Федерации»;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>Устав ООО «АйТи Онлайн»;</Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  договоры, заключаемые между Оператором и субъектами
                  персональных данных;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  согласие субъектов персональных данных на обработку их
                  персональных данных;
                </Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  иные нормативные правовые акты, регулирующие отношения,
                  связанные с деятельностью Оператора.
                </Text>
              </li>
            </ul>
          </section>

          <section>
            <Title className={classes.sectionHeader} level={4}>
              5. Объем и категории обрабатываемых персональных данных
            </Title>
            <p>
              <Text className={classes.sectionText}>
                5.1. Содержание и объем обрабатываемых персональных данных
                должны соответствовать заявленным целям обработки,
                предусмотренным в разделе 3 Политики. Обрабатываемые
                персональные данные не должны быть избыточными по отношению к
                заявленным целям их обработки.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                5.2. Оператор может обрабатывать персональные данные следующих
                категорий субъектов персональных данных:
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                5.2.1. Пользователи Сайта Оператора (не прошедшие регистрацию на
                Сайте) – для целей улучшения функционирования сайта и проведения
                статистических исследований:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>файлы cookie (куки).</Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                5.2.2. Контрагенты Оператора (физические лица, представляющие
                интересы юридических лиц, которые зарегистрированы на сайте) –
                для целей, указанных в пункте 3.3 Политики:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>фамилия, имя, отчество (при наличии);</Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  паспортные данные единоличного исполнительного органа (включая
                  генерального директора) юридического лица, а также учредителей
                  юридического лица;
                </Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  адрес регистрации места жительства учредителей юридического
                  лица, а также единоличного исполнительного органа;
                </Text>
              </li>

              <li className={classes.markListItem}>
                <Text>ИНН</Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  страховой номер индивидуального лицевого счета застрахованного
                  лица (СНИЛС);
                </Text>
              </li>

              <li className={classes.markListItem}>
                <Text>номер мобильного телефона;</Text>
              </li>

              <li className={classes.markListItem}>
                <Text>адрес электронной почты;</Text>
              </li>

              <li className={classes.markListItem}>
                <Text>файлы cookie (куки).</Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                5.3. Оператором не осуществляется обработка специальных
                категорий персональных данных, касающихся расовой, национальной
                принадлежности, политических взглядов, религиозных или
                философских убеждений, состояния здоровья, интимной жизни, за
                исключением случаев, предусмотренных законодательством РФ.
              </Text>
            </p>
          </section>

          <section>
            <Title className={classes.sectionHeader} level={4}>
              6. Условия и порядок обработки персональных данных
            </Title>

            <p>
              <Text className={classes.sectionText}>
                6.1. Оператор осуществляет сбор, запись, систематизацию,
                накопление, хранение, уточнение (обновление, изменение),
                извлечение, использование, передачу (распространение,
                предоставление, доступ), блокирование, удаление и уничтожение
                персональных данных.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.2. Оператор осуществляет обработку персональных данных
                следующими способами:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>неавтоматизированная обработка персональных данных;</Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  автоматизированная обработка персональных данных с получением
                  и/или передачей полученной информации по
                  информационно-телекоммуникационным сетям или без таковой;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>смешанная обработка персональных данных.</Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                6.3. Оператор и иные лица, получившие доступ к персональным
                данным, обязаны не раскрывать третьим лицам и не распространять
                персональные данные без согласия субъекта персональных данных,
                если иное не предусмотрено федеральным законом.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.4. Оператор имеет право получать от субъекта персональных
                данных достоверные информацию и/или документы, содержащие
                персональные данные;
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.5. Лица, передавшие Оператору недостоверные сведения о себе,
                либо сведения о другом субъекте персональных данных без согласия
                последнего, несут ответственность в соответствии с
                законодательством РФ.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.6. Предоставленное Пользователем в соответствии с настоящей
                Политикой Согласие на обработку персональных данных действует со
                дня предоставления такого согласия и в течение срока,
                необходимого для достижения целей обработки персональных данных
                или до момента отзыва Пользователем указанного согласия, если
                иное не предусмотрено законодательством РФ. Пользователь может
                отозвать согласие на обработку персональных данных, направив
                данное требование Оператору по электронной почте.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.7. Согласие субъекта персональных данных на обработку
                персональных данных, разрешенных для распространения,
                оформляется отдельно от других согласий на обработку его
                персональных данных. При этом соблюдаются условия,
                предусмотренные ст. 10.1 Закона о персональных данных.
                Требования к содержанию такого согласия устанавливаются
                уполномоченным органом по защите прав субъектов персональных
                данных.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.7.1. Согласие на обработку персональных данных, разрешенных
                для распространения, субъект персональных данных предоставляет
                Оператору посредством заключения согласия на обработку
                персональных данных, разрешенных для распространения.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.7.2. Субъект персональных данных гарантирует, что в случае
                предоставления персональных данных представителей, они являются
                корректными и актуальными, получены на законных основаниях, в
                том числе посредством согласия представляемых лиц на обработку
                персональных данных.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.7.3. Передача (распространение, предоставление, доступ)
                персональных данных, разрешенных субъектом персональных данных
                для распространения, должна быть прекращена в любое время по
                требованию субъекта персональных данных. Данное требование
                должно включать в себя фамилию, имя, отчество (при наличии),
                контактную информацию (номер телефона, адрес электронной почты
                или почтовый адрес) субъекта персональных данных, а также
                перечень персональных данных, обработка которых подлежит
                прекращению. Указанные в данном требовании персональные данные
                могут обрабатываться только Оператором, которому оно направлено.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.7.4. Согласие на обработку персональных данных, разрешенных
                для распространения, прекращает свое действие с момента
                поступления Оператору требования субъекта персональных данных о
                прекращении обработки его персональных данных, разрешенных для
                распространения.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.8. Оператор прекращает обработку персональных данных в
                следующих случаях:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>
                  выявлен факт их неправомерной обработки. Срок - в течение трех
                  рабочих дней с даты выявления;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>достигнута цель их обработки;</Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  истек срок действия или отозвано согласие субъекта
                  персональных данных на обработку указанных данных, когда по
                  Закону о персональных данных обработка этих данных допускается
                  только с согласия.
                </Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                6.9. При достижении целей обработки персональных данных, а также
                в случае отзыва субъектом персональных данных согласия на их
                обработку Оператор прекращает обработку этих данных, если:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>
                  иное не предусмотрено договором, стороной которого,
                  выгодоприобретателем или поручителем, по которому является
                  субъект персональных данных;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  Оператор не вправе осуществлять обработку без согласия
                  субъекта персональных данных на основаниях, предусмотренных
                  Законом о персональных данных или иными федеральными законами;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  иное не предусмотрено другим соглашением между Оператором и
                  субъектом персональных данных.
                </Text>
              </li>
            </ul>

            <p>
              {" "}
              <Text className={classes.sectionText}>
                6.10. При обращении субъекта персональных данных к Оператору с
                требованием о прекращении обработки персональных данных в срок,
                не превышающий 10 рабочих дней с даты получения Оператором
                соответствующего требования, обработка персональных данных
                прекращается, за исключением случаев, предусмотренных Законом о
                персональных данных. Указанный срок может быть продлен не более
                чем на пять рабочих дней. Для этого Оператору необходимо
                направить субъекту персональных данных мотивированное
                уведомление с указанием причин продления срока.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.11. При получении запроса от уполномоченного органа по защите
                прав, Оператор предоставляет необходимую информацию в течение 30
                дней с даты получения запроса;
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.12. При сборе персональных данных, в том числе посредством
                информационно-телекоммуникационной сети Интернет, Оператор
                обеспечивает запись, систематизацию, накопление, хранение,
                уточнение (обновление, изменение), извлечение персональных
                данных граждан Российской Федерации с использованием баз данных,
                находящихся на территории Российской Федерации, за исключением
                случаев, указанных в Законе о персональных данных.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                6.13. Оператор при обработке персональных данных обеспечивает
                конфиденциальность персональных данных.
              </Text>
            </p>
          </section>

          <section>
            <Title className={classes.sectionHeader} level={4}>
              7. Актуализация, исправление, удаление и уничтожение персональных
              данных, ответы на запросы субъектов на доступ к персональным
              данным
            </Title>
            <p>
              <Text className={classes.sectionText}>
                7.1. Подтверждение факта обработки персональных данных
                Оператором, правовые основания и цели обработки персональных
                данных, а также иные сведения, указанные в ч. 7 ст. 14 Закона о
                персональных данных, предоставляются Оператором субъекту
                персональных данных или его представителю в течение 10 рабочих
                дней с момента обращения либо получения запроса субъекта
                персональных данных или его представителя. Данный срок может
                быть продлен, но не более чем на пять рабочих дней. Для этого
                Оператору следует направить субъекту персональных данных
                мотивированное уведомление с указанием причин продления срока
                предоставления запрашиваемой информации.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.1.1. В предоставляемые сведения не включаются персональные
                данные, относящиеся к другим субъектам персональных данных, за
                исключением случаев, когда имеются законные основания для
                раскрытия таких персональных данных. <br /> Запрос должен
                содержать:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>
                  номер основного документа, удостоверяющего личность субъекта
                  персональных данных или его представителя, сведения о дате
                  выдачи указанного документа и выдавшем его органе;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  сведения, подтверждающие участие субъекта персональных данных
                  в отношениях с Оператором (номер договора, дата заключения
                  договора, условное словесное обозначение и (или) иные
                  сведения), либо сведения, иным образом подтверждающие факт
                  обработки персональных данных Оператором;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  подпись субъекта персональных данных или его представителя.
                </Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                Запрос может быть направлен в форме электронного документа и
                подписан электронной подписью в соответствии с законодательством
                Российской Федерации.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.1.2. Оператор предоставляет сведения, указанные в ч. 7 ст. 14
                Закона о персональных данных, субъекту персональных данных или
                его представителю в той форме, в которой направлены
                соответствующие обращение либо запрос, если иное не указано в
                обращении или запросе.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.1.3. Если в обращении (запросе) субъекта персональных данных
                не отражены в соответствии с требованиями Закона о персональных
                данных все необходимые сведения или субъект не обладает правами
                доступа к запрашиваемой информации, то ему направляется
                мотивированный отказ.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.1.4. Право субъекта персональных данных на доступ к его
                персональным данным может быть ограничено в соответствии с ч. 8
                ст. 14 Закона о персональных данных, в том числе если доступ
                субъекта персональных данных к его персональным данным нарушает
                права и законные интересы третьих лиц.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.2. В случае выявления неточных персональных данных при
                обращении субъекта персональных данных или его представителя
                либо по их запросу или по запросу Роскомнадзора Оператор
                осуществляет блокирование персональных данных, относящихся к
                этому субъекту персональных данных, с момента такого обращения
                или получения указанного запроса на период проверки, если
                блокирование персональных данных не нарушает права и законные
                интересы субъекта персональных данных или третьих лиц. <br /> В
                случае подтверждения факта неточности персональных данных
                Оператор на основании сведений, представленных субъектом
                персональных данных или его представителем либо Роскомнадзором,
                или иных необходимых документов уточняет персональные данные в
                течение семи рабочих дней со дня представления таких сведений и
                снимает блокирование персональных данных.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.3. В случае выявления неправомерной обработки персональных
                данных при обращении (запросе) субъекта персональных данных или
                его представителя либо Роскомнадзора Оператор осуществляет
                блокирование неправомерно обрабатываемых персональных данных,
                относящихся к этому субъекту персональных данных, с момента
                такого обращения или получения запроса.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.4. При выявлении факта неправомерной или случайной передачи
                (предоставления, распространения) персональных данных (доступа к
                персональным данным), повлекшей нарушение прав субъектов
                персональных данных, Оператор:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>
                  {" "}
                  в течение 24 часов – уведомляет Роскомнадзор о произошедшем
                  инциденте, предполагаемых причинах, повлекших нарушение прав
                  субъектов персональных данных, предполагаемом вреде,
                  нанесенном правам субъектов персональных данных, и принятых
                  мерах по устранению последствий инцидента, а также
                  предоставляет сведения о лице, уполномоченном Оператором на
                  взаимодействие с Роскомнадзором по вопросам, связанным с
                  инцидентом;
                </Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  в течение 72 часов – уведомляет Роскомнадзор о результатах
                  внутреннего расследования выявленного инцидента и
                  предоставляет сведения о лицах, действия которых стали его
                  причиной (при наличии).
                </Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                7.5. Порядок уничтожения персональных данных Оператором:
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.5.1. Условия и сроки уничтожения персональных данных
                Оператором:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>
                  достижение цели обработки персональных данных либо утрата
                  необходимости достигать эту цель – в течение 30 дней;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  достижение максимальных сроков хранения документов, содержащих
                  персональные данные, – в течение 30 дней;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  предоставление субъектом персональных данных (его
                  представителем) подтверждения того, что персональные данные
                  получены незаконно или не являются необходимыми для заявленной
                  цели обработки, – в течение семи рабочих дней;
                </Text>
              </li>

              <li className={classes.markListItem}>
                <Text>
                  отзыв субъектом персональных данных согласия на обработку его
                  персональных данных, если их сохранение для цели их обработки
                  более не требуется, – в течение 30 дней.
                </Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                7.5.2. При достижении цели обработки персональных данных, а
                также в случае отзыва субъектом персональных данных согласия на
                их обработку персональные данные подлежат уничтожению, если:
              </Text>
            </p>

            <ul className={classes.markList}>
              <li className={classes.markListItem}>
                <Text>
                  иное не предусмотрено договором, стороной которого,
                  выгодоприобретателем или поручителем по которому является
                  субъект персональных данных;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  оператор не вправе осуществлять обработку без согласия
                  субъекта персональных данных на основаниях, предусмотренных
                  Законом о персональных данных или иными федеральными законами;
                </Text>
              </li>
              <li className={classes.markListItem}>
                <Text>
                  иное не предусмотрено другим соглашением между Оператором и
                  субъектом персональных данных.
                </Text>
              </li>
            </ul>

            <p>
              <Text className={classes.sectionText}>
                7.5.3. Уничтожение персональных данных осуществляет комиссия,
                созданная приказом генерального директора ООО «АйТи Онлайн».
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                7.5.4. Способы уничтожения персональных данных устанавливаются в
                локальных нормативных актах Оператора.
              </Text>
            </p>
          </section>

          <section>
            <Title className={classes.sectionHeader} level={4}>
              8. Заключительные положения
            </Title>

            <p>
              <Text className={classes.sectionText}>
                8.1. Субъект персональных данных может получить любые
                разъяснения по интересующим вопросам и направлять обращения,
                касающиеся обработки его персональных данных, обратившись к
                Оператору по адресу электронной почты{" "}
                <a
                  href={`mailto:${process.env.REACT_APP_IT_ONLINE_MAIL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {process.env.REACT_APP_IT_ONLINE_MAIL}
                </a>
                .
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                8.2. В данном документе будут отражены любые изменения политики
                обработки персональных данных Оператором. Политика действует
                бессрочно до замены ее новой версией.
              </Text>
            </p>

            <p>
              <Text className={classes.sectionText}>
                8.3. Во исполнение требование ч.2 ст. 18.1 Закона о персональных
                данных актуальная версия настоящей Политики в свободном доступе
                расположена в сети Интернет по адресу{" "}
                <a
                  href="https://tatbg.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tatbg.ru/
                </a>
              </Text>
            </p>
          </section>
        </div>
      </div>
    </LoginFormLayout>
  );
}
